/**
 * Pasek na dole ekranu: kilka średnich przycisków i to, co się nad nimi
 * rozwija.
 *
 * **Jeden otwarty naraz i to jest cała reguła tego pliku.** Panele rozwijają
 * się w tym samym miejscu — nad paskiem — więc dwa otwarte zasłaniałyby się
 * nawzajem; a że każdy z nich odpowiada na inne pytanie, jednoczesne otwarcie
 * dwóch i tak nie ma sensu.
 *
 * **Pasek nie wie, co jest w panelach.** Dostaje gotowe elementy i pokazuje je
 * albo chowa. Budowanie zna katalog, handel zna transporty, a to zna wyłącznie
 * układ — inaczej byłby trzecim miejscem, które trzeba dopisać przy każdej
 * nowej zakładce.
 */

export interface HudTab {
  key: string;
  label: string;
  /** Element rozwijany nad paskiem. Nie jest przez ten plik budowany. */
  panel: HTMLElement;
  /** Wołane przy otwarciu — zakładka bywa widokiem czegoś, co trzeba odświeżyć. */
  onOpen?: () => void;
}

export class HudBar {
  private readonly root = document.createElement('div');
  private readonly bar = document.createElement('div');
  private readonly stack = document.createElement('div');
  private readonly buttons = new Map<string, HTMLButtonElement>();
  private shown: string | null = null;

  constructor(
    container: HTMLElement,
    private readonly tabs: HudTab[]
  ) {
    this.root.className = 'hud';
    this.stack.className = 'hud-stack';
    this.bar.className = 'hud-bar';

    for (const tab of tabs) {
      tab.panel.classList.add('hud-panel');
      tab.panel.hidden = true;
      this.stack.appendChild(tab.panel);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'hud-button';
      button.textContent = tab.label;
      button.addEventListener('click', () => this.show(this.shown === tab.key ? null : tab.key));
      this.buttons.set(tab.key, button);
      this.bar.appendChild(button);
    }

    this.root.append(this.stack, this.bar);
    container.appendChild(this.root);
  }

  /** Która zakładka jest otwarta, albo `null`. */
  get openTab(): string | null {
    return this.shown;
  }

  /** Otwórz jedną, zamykając to, co było. `null` zamyka wszystko. */
  show(key: string | null): void {
    this.shown = key;

    for (const tab of this.tabs) {
      const chosen = tab.key === key;
      tab.panel.hidden = !chosen;
      this.buttons.get(tab.key)?.classList.toggle('is-open', chosen);
      if (chosen) tab.onOpen?.();
    }
  }

  /** Zamknij to, co otwarte. Odpowiada, czy było co zamykać. */
  close(): boolean {
    if (this.shown === null) return false;
    this.show(null);
    return true;
  }

  dispose(): void {
    this.root.remove();
  }
}
